import axios from "./config";
import { API } from "./api";

export const getRoomsInfoByMultipleProject = async (projects) => {
  const responses = Promise.allSettled(
    projects.map(async (project) => {
      if (project.layersInfo?.length) {
        return project;
      }

      const res = await axios({
        method: "get",
        url: `${API.siteRepo.root}${API.siteRepo.getLayerByProject.replace("{0}", project.mprojectId)}`,
      });
      return {
        ...project,
        layersInfo: res.data.map((layer, index) => {
          layer.elementIndex = index;
          layer.pictureData = null;
          return layer;
        }),
      };
    }),
  );

  return responses.then((projectsResp) => Promise.resolve(projectsResp)).catch((er) => console.error(er));
};

export const getFloorImages = async (projects) => {
  const response = projects.map(async (project) => {
    const setteled = Promise.allSettled(
      (project?.layersInfo ?? []).map(async (layer) => {
        if (!layer.pictureData) {
          const res = await axios({
            method: "get",
            url: `${API.siteRepo.root}${API.siteRepo.getImagesByFloor.replace("{0}", project.mprojectId).replace("{1}", layer.index)}`,
            responseType: "arraybuffer",
            headers: { accept: "image/jpeg" },
          });

          let image = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));

          return { ...layer, pictureData: `data:${res.headers["content-type"].toLowerCase()};base64,${image}` };
        }
        return layer;
      }),
    );

    const floorsResponse = await setteled;
    return {
      mprojectId: project.mprojectId,
      layersInfo: floorsResponse,
      elementIndex: project.elementIndex,
      domId: project.domId,
    };
  });

  return await Promise.all(response).then((re) => re);
};

export const createNewSite = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.createSite}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const searchSite = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.searchSite}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getSite = async (siteId) => {
  let config = {
    method: "get",
    url: `${API.siteRepo.root}${API.siteRepo.getSite.replace("{0}", siteId)}`,
  };

  return axios(config)
    .then(function (response) {
      return Promise.resolve(response.data);
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const deleteLayer = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.deleteLayer}`, body)
    .then(function (response) {
      return Promise.resolve(response.data);
    })
    .catch(function (error) {
      console.error(error);
    });
};

export const getlaborCodeList = async () => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.getLaborCodes}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const addLaborCodeToProduct = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.addLaborCodeToProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const deleteLaborCodeService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.deleteLaborCodeFromProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const updateProductService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.updateProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const bulkUpdateSiteService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.updateSiteProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const deleteProductService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.deleteProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const addManualProductService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.addProduct}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const createQuoteFromSiteService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.createQuote}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getCutSheetsService = async (projectId) => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.getCutSheetsData.replace("{0}", projectId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const updateRoomService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.updateRoom}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getAllSiteNamesService = async () => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.getAllSiteNames}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const bulkUpdateProductsService = async (body) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.updateProductsInBulk}`, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getChangeLogService = async (siteId) => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.getChangeLog.replace("{0}", siteId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getRerunBulkUpdateService = async (siteId) => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.rerunBulkUpdate.replace("{0}", siteId)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const deleteMeasurementService = async (data) => {
  return axios
    .post(`${API.siteRepo.root}${API.siteRepo.deleteMeasurement}`, data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
